import documentSaver from 'serviceWorker/services/documents/addDocument';
import drawingSaver from 'serviceWorker/services/documents/addDrawing';
import documentDeleter from 'serviceWorker/services/documents/deleteDocument';
import documentEditor from 'serviceWorker/services/documents/editDocument';
import {
  getDocumentsOfParent,
  getDocumentUrlsOfLocalId,
  getSharedDocumentSignedUrl,
} from 'serviceWorker/services/documents';
import { readIssueAttachmentCounts } from 'serviceWorker/services/documents/issueAttachmentCounts';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { documentContract } from 'shared/domain/document/documentContract';

/** Answers document (attachment) requests of the page. */
export function serveDocumentRequests(): ChannelUnsubscribe {
  return channelServer.handle(documentContract, {
    getOfParent: getDocumentsOfParent,
    countAttachmentsOfIssues: ({ issueIds }) => readIssueAttachmentCounts(issueIds),
    create: ({ baseUrl, document, uniqueId }) => documentSaver.execute(baseUrl, document, uniqueId),
    edit: (change) => documentEditor.execute(change.localId, change),
    remove: ({ localId }) => documentDeleter.execute(localId),
    createDrawing: ({ drawing, localId }) => drawingSaver.execute(drawing, localId),
    getUrls: getDocumentUrlsOfLocalId,
    getSignedUrlSecuredByToken: getSharedDocumentSignedUrl,
  });
}
